import { render, staticRenderFns } from "./StatisticCleanLayout.vue?vue&type=template&id=7dc99602&scoped=true&"
import script from "./StatisticCleanLayout.vue?vue&type=script&lang=js&"
export * from "./StatisticCleanLayout.vue?vue&type=script&lang=js&"
import style0 from "./StatisticCleanLayout.vue?vue&type=style&index=0&id=7dc99602&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc99602",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VContainer,VMain})
